var exports = {
  "O7": "FluxerTagChangeModal.module__fluxerTagContainer___SWJ1NF",
  "To": "FluxerTagChangeModal.module__fluxerTagLabel___SWJ1NF",
  "Nr": "FluxerTagChangeModal.module__fluxerTagInputRow___SWJ1NF",
  "jo": "FluxerTagChangeModal.module__usernameInput___SWJ1NF",
  "Ye": "FluxerTagChangeModal.module__errorBox___SWJ1NF",
  "jY": "FluxerTagChangeModal.module__validationBox___SWJ1NF",
};

module.exports = exports;
